<template>
  <v-card class="card-gantt">
    <!-- Vérifier si le tableau 'events' est vide -->
    <div
      v-if="events.length === 0"
      class="no-data-card text-center mt-5 mb-4"
      lg="3"
    >
      {{ $t("messages.information.no_data") }}
    </div>

    <!-- Afficher le contenu Gantt seulement si 'events' contient des données -->
    <div v-else>
      <v-container class="pa-0">
        <gantt-elastic
          :options="options"
          :tasks="events"
        >
          <gantt-header
            slot="header"
            :options="options"
          ></gantt-header>
        </gantt-elastic>
        <div class="q-mt-md" />
      </v-container>
    </div>
  </v-card>
</template>

<style>
.card-gantt {
  border-radius: 16px !important;
  background: white;
  padding: 10px;
}
</style>

<script>
import GanttElastic from "gantt-elastic"
import GanttHeader from "./HeaderComponent.vue"

let self

// Créez une fonction pour initialiser les options
const initializeOptions = () => {
  return {
    taskMapping: {
      progress: "percent"
    },
    maxRows: 100,
    maxHeight: 500,
    title: {
      label: "Your project title as html (link or whatever...)",
      html: false
    },
    row: {
      height: 24
    },
    calendar: {
      hour: {
        display: true
      }
    },
    chart: {
      progress: {
        bar: false
      },
      expander: {
        display: true
      }
    },
    taskList: {
      expander: {
        straight: false
      },
      columns: [
        {
          id: 2,
          label: self.$t("views.gantt.description"),
          value: "label",
          width: 200,
          expander: true,
          html: true,
          events: {
            click({ data, column }) {
              self.redirectToProjectTaskEdit(data.project_id)
            }
          }
        }
      ]
    },
    locale: {
      name: self.$t("views.gantt.lang"),
      weekStart: 1,
      weekdays: self.$t("views.gantt.weekdays").split("_"),
      months: self.$t("views.gantt.months").split("_"),
      monthsShort: self.$t("views.gantt.monthsShort").split("_")
    }
  }
}

export default {
  name: "GanttComponent",
  components: {
    GanttElastic,
    GanttHeader
  },
  props: {
    events: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      transformedData: this.events,
      options: {},
      dynamicStyle: {}
    }
  },
  watch: {
    "$i18n.locale": function (newLocale) {
      // Mettez à jour les traductions ou tout autre traitement nécessaire
      this.options.locale.weekdays = this.$t("views.gantt.weekdays").split("_")
      this.options.locale.months = this.$t("views.gantt.months").split("_")
      this.options.locale.monthsShort = this.$t("views.gantt.monthsShort").split("_")
      this.options.locale.lang = this.$t("views.gantt.lang").split("_")
      this.options.locale.description = this.$t("views.gantt.description")
    }
  },
  created() {
    self = this
    this.options = initializeOptions() // Initialisez les options avec la référence correcte à 'this'
  },
  methods: {
    redirectToProjectTaskEdit(id) {
      this.$router.push({
        name: "ProjectCreateUpdate",
        params: { id, tab: 2 }
      })
    }
  }
}
</script>
<style>
.gantt-elastic__main-container-wrapper {
  border-radius: 15px;
}
</style>
